import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMultiLevelSortCriteria } from 'ctm-util-functions/lib/multi_sorting_config';
import { quoteFormSelector } from 'ctm-selectors';
import { Icon } from '../../icon/icon';
import { Anchor } from '../../anchor/anchor';
import styles from './frequency_toggle.css';

const frequencyOptions = ['annual', 'monthly'];

/**
 * Handles the on change method
 * @param {string} label - the frequency label
 * @param {string} frequency - the frequency value
 * @param {Function} sortResults - handles sorting results with the frequency value
 * @param {Function} sortArrayMultiLevel -handles sorting results with multiple levels of sorting criteria
 * @param {Function} setFrequencyFilter - sets the frequency value
 * @param {string} coverType - the cover type value to determine the multi-level sorting criteria
 * @returns {Node} Returns the FrequencyToggle component
 */
const _FrequencyToggle = ({ label, frequency, sortResults, sortArrayMultiLevel, setFrequencyFilter, coverType }) => {
    const onClick = () => {
        const frequencyToSet = frequency === frequencyOptions[0] ? frequencyOptions[1] : frequencyOptions[0];
        sortResults(frequencyToSet);
        sortArrayMultiLevel(frequencyToSet, coverType);
        setFrequencyFilter(frequencyToSet);
    };
    return (
        <div>
            <Anchor onClick={onClick} className={styles.anchor}>
                <span className={styles.frequency}>{label}</span>
                <Icon className={styles.icon} variant="ctm_reload" />
            </Anchor>
        </div>
    );
};

_FrequencyToggle.propTypes = {
    label: PropTypes.string.isRequired,
    frequency: PropTypes.string.isRequired,
    sortResults: PropTypes.func.isRequired,
    sortArrayMultiLevel: PropTypes.func.isRequired,
    setFrequencyFilter: PropTypes.func.isRequired,
    coverType: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        // Read coverType from the vertical form state using selector to avoid state shape coupling
        coverType: quoteFormSelector(state).getIn(['coverDetails', 'coverType']) || null
    };
};

const mapDispatchToProps = (dispatch) => ({
    sortResults: (frequency) => {
        dispatch({
            type: 'SORT_RESULTS',
            sortBy: `productMeta.price.${frequency}Premium`,
            sortDir: 'asc',
            sortType: 'numeric'
        });
    },
    sortArrayMultiLevel: (frequency, coverType) => {
        dispatch({
            type: 'SORT_ARRAY_MULTI_LEVEL',
            sortCriteria: getMultiLevelSortCriteria(frequency, coverType)
        });
    },
    setFrequencyFilter: (frequency) => {
        dispatch({
            type: 'SET_FILTER_VALUE',
            filter: 'frequency',
            filterValue: frequency
        });
    }
});

const FrequencyToggle = connect(mapStateToProps, mapDispatchToProps)(_FrequencyToggle);

export { FrequencyToggle, _FrequencyToggle };
